'use client';

import { Skeleton, Stack, Typography } from "@mui/material";
import { LocationOn } from "@mui/icons-material";
import { Contact } from "@/app/lib/generated/graphql-types";
import Link from "next/link";

export default function FooterContactViewDesktop({ contact }: { contact: Contact}) {
    return (
        <Stack component={Link} href="/contact" aria-label="Kontakt" prefetch spacing={2} direction="row" sx={{ alignItems: 'center' }}>
            <LocationOn />
            <Typography variant="body2" fontWeight="bold">
                {`${contact.address.street}, ${contact.address.zipCode} ${contact.address.city}`}
            </Typography>
        </Stack>
    )
}

export const FooterContactViewDesktopSkeleton = () => {
    return (
        <Stack spacing={2} direction="row" sx={{ alignItems: 'center' }}>
            <LocationOn />
            <Skeleton variant="text" width="100%">
                <Typography variant="body2" fontWeight="bold">Street, ZipCode City</Typography>
            </Skeleton>
        </Stack>
    )
}